module.exports = __webpack_public_path__ + "static/project-1b-16cee0b803347f34d18e0e109edb547a.png";